import { createSlice } from "@reduxjs/toolkit";

const initalcompanyAdminState = {
  teamPerformance: {
    data: [],
    loading: false,
  },
};

const companyAdmin = createSlice({
  name: "companyAdmin",
  initialState: initalcompanyAdminState,
  reducers: {
    getcompanyPerformanceSaga(state) {
      state.teamPerformance.loading = true;
    },
    getcompanyPerformance(state, action) {
      state.teamPerformance.data = action.payload?.data;
      state.teamPerformance.loading = false;
    },
    getcompanyPerformanceFail(state) {
      state.teamPerformance.data = [];
      state.teamPerformance.loading = false;
    },
  },
});
export const companyAdminAction = companyAdmin.actions;
export default companyAdmin.reducer;
